// @flow

import { createActions, handleActions } from 'redux-actions'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import RestClient from 'frontend_core/dist/rest/client'
import SMConst from 'frontend_core/dist/constants/sm-const'
import { SET_UI_STATE } from './ui'
import { actions as RoomActions } from './room'
import { actions as LocalRoomsActions } from './local/rooms'
import { type FavoriteList } from 'types/favorite'
import { type ReservationsType } from 'types/reservation'

const PER_PAGE_FOR_RESERVATION_LIST = 20

/**
 ************************************************************
 * 初期ステート
 ************************************************************
 **/

export type State = {
  reservations: Array<ReservationsType>,
  isSuccessFetchReservations: boolean,
  isFetchReservationDetailEnd: boolean,
  failedFetchReservationsMessage: ?string,
  fetchReservationDetailPage: number,
}
const initialState: State = {
  reservations: [],
  isSuccessFetchReservations: false,
  isFetchReservationDetailEnd: false,
  failedFetchReservationsMessage: null,
  fetchReservationDetailPage: 1,
}

/**
 ************************************************************
 * ActionTypes
 ************************************************************
 **/

const actionTypes = {
  INITIALIZE_RESERVATIONS: 'INITIALIZE_RESERVATIONS',
  FETCH_RESERVATIONS: 'FETCH_RESERVATIONS',
  SET_RESERVATIONS: 'SET_RESERVATIONS',
  FAILED_RESERVATIONS: 'FAILED_RESERVATIONS',
}

/**
 ************************************************************
 * Actions
 ************************************************************
 **/

export const actions = createActions(
  actionTypes.INITIALIZE_RESERVATIONS,
  actionTypes.FETCH_RESERVATIONS,
  actionTypes.SET_RESERVATIONS,
  actionTypes.FAILED_RESERVATIONS,
)

/**
 ************************************************************
 * reducer
 ************************************************************
 **/

export const reducer = handleActions(
  {
    [actionTypes.INITIALIZE_RESERVATIONS]: state => ({
      ...state,
      failedFetchReservationsMessage: null,
      reservations: [],
      isSuccessFetchReservations: false,
      isFetchReservationDetailEnd: false,
      fetchReservationDetailPage: 1,
    }),
    [actionTypes.FETCH_RESERVATIONS]: state => ({
      ...state,
      failedFetchReservationsMessage: null,
      isSuccessFetchReservations: false,
    }),
    [actionTypes.SET_RESERVATIONS]: (state, action) => ({
      ...state,
      reservations: (state.reservations || []).concat(action.payload),
      isSuccessFetchReservations: true,
      isFetchReservationDetailEnd:
        action.payload.length < PER_PAGE_FOR_RESERVATION_LIST,
      fetchReservationDetailPage: state.fetchReservationDetailPage + 1,
    }),
    [actionTypes.FAILED_RESERVATIONS]: (state, action) => ({
      ...state,
      failedFetchReservationsMessage: action.payload,
    }),
  },
  initialState,
)

/**
 ************************************************************
 * API連携 非同期アクション
 ************************************************************
 **/

// 予約一覧取得
function* initializeReservations({ payload }: { payload: { userId: string } }) {
  yield put(
    actions.fetchReservations({
      ...payload,
      page: 1,
    }),
  )
}

function* fetchReservations({
  payload,
}: {
  payload: { userId: string, page: number },
}) {
  const { userId, page } = payload
  try {
    const reservations = yield call(
      RestClient.get,
      `1/users/${userId}/reservations?sort=updated&per_page=${PER_PAGE_FOR_RESERVATION_LIST}&page=${page}`,
    )
    // 以前存在していた法人コンシェルのデータはすでに不要なためフィルタ
    yield put({
      type: actionTypes.SET_RESERVATIONS,
      payload: reservations.filter(
        reservation =>
          reservation.method !== SMConst.ReservationMethod.Concierge,
      ),
    })
  } catch (e) {
    yield put(actions.failedReservations(e.message))
  }
}

/**
 ************************************************************
 * saga
 ************************************************************
 **/

export const reservationSagas = [
  takeEvery(actionTypes.FETCH_RESERVATIONS, fetchReservations),
  takeEvery(actionTypes.INITIALIZE_RESERVATIONS, initializeReservations),
]



// WEBPACK FOOTER //
// ./src/redux/modules/reservation.js